import AsyncStorage from "@react-native-async-storage/async-storage";
import { StyleSheet, Text, TextInput, TouchableOpacity, View } from "react-native";
import { useTranslation } from "react-i18next";
import { CheckCircleIcon, RadioIcon } from "../../assets/icons";
import SurveyQuestionCard from "./SurveyQuestionCard";
import ModalMenuDropdown from "../ModalMenuDropdown";
import ModalMenuMultipleDropdown from "../ModalMenuMultipleDropdown";
import ModalMenuMultipleDropdownManual from "../ModalMenuMultipleDropdownManual";
import { useEffect, useState } from "react";
import OtherOptions from "../OtherOptions";
import ModalDate from "../ModalDate";
import ModalMenuMultipleDropdownSubquestion from "../ModalMenuMultipleDropdownSubquestion";
import i18n from "../../translation/index";
import { sendLogs } from "../../services/screening";

const SurveyDetailCard = ({ data, answer, handleAnswer, isNewPractice, questionNumber, doesSectionExists, section, sectionNumbers, setListChosenAll, listChosenAll, memberId, refId, quizId }) => {
  const { t } = useTranslation();
  const { orderNo, title, quizType, detail, parentId} = data;
  const isSingleChoice = quizType === "single_choice";
  const detailOptions = JSON.parse(detail)?.options;
  const filteredFrom = JSON.parse(detail)?.filter_from;
  const filteredTo = JSON.parse(detail)?.filter_to;
  const noOptionPlaceholder = JSON.parse(detail)?.no_option;
  const [isOther, setIsOther] = useState(false);
  const [otherAnswer, setOtherAnswer] = useState({});
  const [otherAnswerString, setOtherAnswerString] = useState("");
  const [options, setOptions] = useState({});
  const [filteredFromAnswer, setFilteredFromAnswer] = useState([]);
  const [filteredToAnswer, setFilteredToAnswer] = useState([]);

  useEffect(() => {
    let tempFilteredFromAnswer = filteredFrom ? Object.keys(answer)?.filter((i) => i === `no-${filteredFrom}`) : [];
    tempFilteredFromAnswer = filteredFrom ?
      filteredFrom.replace(/ /g, "").split(",").map((theNumber) => {
        const tempFiltered = Object.keys(answer)?.filter((i) => i === `no-${theNumber}`);
        return tempFiltered.join();
      })
      : 
      [];
    setFilteredFromAnswer(tempFilteredFromAnswer);

    const tempFilteredToAnswer = filteredTo ? Object.keys(answer)?.filter((i) => i === `no-${filteredTo}`) : [];
    setFilteredToAnswer(tempFilteredToAnswer);
  }, [answer]);

  useEffect(() => {
    if (!otherAnswer[data.rowId] || !isOther) {
      return;
    }
    let tempAnser = [];
    if (otherAnswer[data.rowId]['cat']) {
      tempAnser.push(otherAnswer[data.rowId]['cat']);
    }
    if (otherAnswer[data.rowId]['subcat']) {
      tempAnser.push(otherAnswer[data.rowId]['subcat']);
    }
    if (otherAnswer[data.rowId]['value']) {
      tempAnser.push(otherAnswer[data.rowId]['value']);
    }
    if (tempAnser.length < 3) {
      let newAnswer = answer;
      delete newAnswer[data.rowId];
      delete newAnswer[`no-${orderNo}`];
      return handleAnswer({ ...newAnswer });
    }
    handleAnswer({ ...answer, [data.rowId]: `${tempAnser.join(" - ")}`, [`no-${orderNo}`]: `${tempAnser.join(" - ")}` });
  }, [otherAnswerString]);

  useEffect(() => {
    async function getLang() {
      return await AsyncStorage.getItem("lang");
    }

    getLang()
    .then((res) => {
      if (!res) {
        AsyncStorage.setItem("lang", "id");
        i18n.changeLanguage("id");
        return;
      }
      AsyncStorage.setItem("lang", res);
      i18n.changeLanguage(res);
    });
  }, []);

  return (
    <SurveyQuestionCard number={questionNumber} type={quizType} question={title} parentId={parentId} doesSectionExists={doesSectionExists} section={section}  sectionNumbers={sectionNumbers}>
      {quizType === "free_text" || quizType === "short_text" ? (
        <TextInput
          multiline={quizType === "free_text" ? true : false}
          placeholder={`${t("survey:placeholder-write")}`}
          style={[styles.textInput, styles.optionTx, {height: quizType === "free_text" ? 100 : 48}]}
          placeholderTextColor="#999"
          value={answer[data.rowId]}
          onChangeText={(val) => {
            if (val === "") {
              let newAnswer = answer;
              delete newAnswer[data.rowId];
              delete newAnswer[`no-${orderNo}`];
              return handleAnswer({ ...newAnswer });
            }
            handleAnswer({
              ...answer,
              [data.rowId]: val, 
              [`no-${orderNo}`]: val
            });
          }}
          onBlur={(e) => {
            if (e.target.value !== "") {
              sendLogs({
                "quiz_id": quizId,
                "detail_id": data.rowId, 
                "member_id": memberId, 
                "ref_id": refId, 
                "answers": e.target.value
              });
            }
          }}
        />
      ) : (quizType === "data_source" && (isNewPractice === 0 || !isNewPractice)) ? (
        <ModalMenuDropdown
          options={detailOptions}
          filteredFromAnswer={filteredFromAnswer}
          isSearch
          value={answer?.[data.rowId]}
          quizType={quizType}
          data={data}
          answer={answer}
          onChange={(value) => {
            handleAnswer({ ...answer, [data.rowId]: value, [`no-${orderNo}`]: value});
            sendLogs({
              "quiz_id": quizId,
              "detail_id": data.rowId, 
              "member_id": memberId, 
              "ref_id": refId, 
              "answers": value
            });
          }}
        />
      )  : (quizType === "date") ? (
        <ModalDate
          value={answer?.[data.rowId]}
          quizType={quizType}
          data={data}
          onChange={(value) => {
            handleAnswer({ ...answer, [data.rowId]: value, [`no-${orderNo}`]: value });
            sendLogs({
              "quiz_id": quizId,
              "detail_id": data.rowId, 
              "member_id": memberId, 
              "ref_id": refId, 
              "answers": value
            });
          }}
        />
      ) : ((quizType === "data_source_multiple_no_option" || quizType === "data_source_multiple" || quizType === "data_source" || quizType === "data_source_associate") && parseInt(isNewPractice) === 1  && (parentId == "" || parentId == "null" || !parentId)) ? (
          <ModalMenuMultipleDropdown
            noOptionPlaceholder={noOptionPlaceholder}
            options={detailOptions}
            filteredFromAnswer={filteredFromAnswer}
            filteredToAnswer={filteredToAnswer}
            value={answer?.[data.rowId]}
            quizType={quizType}
            data={data}
            isNewPractice={isNewPractice}
            answer={answer}
            onChange={(value) => {
              sendLogs({
                "quiz_id": quizId,
                "detail_id": data.rowId, 
                "member_id": memberId, 
                "ref_id": refId, 
                "answers": value
              });

              if (value === "") {
                let newAnswer = answer;
                delete newAnswer[data.rowId];
                delete newAnswer[`no-${orderNo}`];
                return handleAnswer({ ...newAnswer });
              }
              handleAnswer({ ...answer, [data.rowId]: value, [`no-${orderNo}`]: value });
            }}
          />
      ) : ((quizType === "data_source_multiple_no_option" || quizType === "data_source_multiple" || quizType === "data_source" || quizType === "data_source_associate") && parseInt(isNewPractice) === 1 && (parentId && parentId != "" && parentId != "null")) ? (
          <ModalMenuMultipleDropdownSubquestion
            options={detailOptions}
            noOptionPlaceholder={noOptionPlaceholder}
            setListChosenAll={setListChosenAll}
            listChosenAll={listChosenAll}
            filteredFromAnswer={filteredFromAnswer}
            filteredToAnswer={filteredToAnswer}
            value={answer?.[data.rowId]}
            quizType={quizType}
            question={title}
            data={data}
            isNewPractice={isNewPractice}
            answer={answer}
            onChange={(value) => {
              sendLogs({
                "quiz_id": quizId,
                "detail_id": data.rowId, 
                "member_id": memberId, 
                "ref_id": refId, 
                "answers": value
              });

              if (value === "") {
                let newAnswer = answer;
                delete newAnswer[data.rowId];
                delete newAnswer[`no-${orderNo}`];
                return handleAnswer({ ...newAnswer });
              }
              handleAnswer({ ...answer, [data.rowId]: value, [`no-${orderNo}`]: value });
            }}
          />
      ) : (quizType === "data_source_multiple_manual" && parseInt(isNewPractice) === 1) ? (
        <View>
          <ModalMenuMultipleDropdownManual
            options={detailOptions}
            filteredFromAnswer={filteredFromAnswer}
            value={answer?.[data.rowId]}
            quizType={quizType}
            data={data}
            isNewPractice={isNewPractice}
            otherAnswer={otherAnswer}
            onChange={(value) => {
              sendLogs({
                "quiz_id": quizId,
                "detail_id": data.rowId, 
                "member_id": memberId, 
                "ref_id": refId, 
                "answers": value
              });

              if (value === "") {
                let newAnswer = answer;
                delete newAnswer[data.rowId];
                delete newAnswer[`no-${orderNo}`];
                return handleAnswer({ ...newAnswer });
              }
              setIsOther(false);
              if (value?.value === "Lainnya") {
                setIsOther(true);
                setOptions(value?.tempOptions);
              }
              handleAnswer({ ...answer, [data.rowId]: value?.value === "Lainnya" ? "Lainnya" : value });
            }}
          />
          {
            isOther &&
            options &&
            <View 
              style={{
                backgroundColor: "#F3F3F3",
                borderColor: "#EAEAEA",
                borderRadius: 10,
                padding: 12,
                marginTop: 10
              }}
            >
              <Text style={{fontFamily: "Archivo-Bold", fontSize: 12}}>
                Tuliskan perilaku lainnya
              </Text>
              <TextInput
                placeholder="Tulis atau pilih perilaku"
                style={{...styles.textInput, height: 48, backgroundColor: "#FFF", fontFamily: "Archivo-Regular", fontSize: 12, marginTop: 10}}
                onChangeText={(val) => {
                  const tempOtherAnswer = otherAnswer;
                  if (!tempOtherAnswer[data.rowId]) {
                    tempOtherAnswer[data.rowId] = {};
                  }
                  tempOtherAnswer[data.rowId]['value'] = val;

                  setOtherAnswer(tempOtherAnswer);
                  setOtherAnswerString(JSON.stringify(tempOtherAnswer));
                }}
              />
              <Text style={{fontFamily: "Archivo-Bold", fontSize: 12, marginTop: 10}}>
                Kategori perilaku lainnya
              </Text>
              <View 
                style={{
                  justifyContent: "space-between",
                  flexDirection: "row",
                  marginTop: 10,
                  flexFlow: "wrap"
                }}
              >
                {
                  Object.keys(options[0]).map((b, j) => {
                    return Object.keys(options[0][b]).map((c, k) => {
                      return <OtherOptions c={c} otherAnswer={otherAnswer} setOtherAnswer={setOtherAnswer} setOtherAnswerString={setOtherAnswerString} data={data}/>
                    });
                  })
                }
              </View>
              <Text style={{fontFamily: "Archivo-Bold", fontSize: 12, marginTop: 10}}>
                Jenis Perilaku Lainnya
              </Text>
              <View 
                style={{
                  justifyContent: "space-between",
                  flexDirection: "row",
                  marginTop: 10
                }}
              >
                {
                  options.map((a, i) => {
                    // get key
                    return Object.keys(a).map((b, j) => {
                      return <TouchableOpacity
                      style={{...styles.option, width: "48%", backgroundColor: "#FFF", paddingVertical: 8, paddingHorizontal: 12}}
                      onPress={() => {
                        const tempOtherAnswer = otherAnswer;
                        if (!tempOtherAnswer[data.rowId]) {
                          tempOtherAnswer[data.rowId] = {};
                        }
                        tempOtherAnswer[data.rowId]['cat'] = b;
                        setOtherAnswer(tempOtherAnswer);
                        setOtherAnswerString(JSON.stringify(tempOtherAnswer));
                      }}
                    >
                      <RadioIcon
                        isSelected={otherAnswer[data.rowId]?.['cat'] === b}
                        style={{ flexShrink: 0 }}
                      />
                      <Text style={[styles.optionTx, { maxWidth: "90%", textTransform: "capitalize" }]}>{b}</Text>
                    </TouchableOpacity>;
                    });
                  })
                }
              </View>
            </View>
          }
        </View>
      ) : (
        quizType !== "section" &&
        Array.isArray(detailOptions) &&
        JSON.parse(detail)?.options?.map((opt, id) => {
          return (
          <TouchableOpacity
            key={id}
            style={styles.option}
            onPress={() => {
              let value;
              if (isSingleChoice) {
                value = opt;
              } else if (Array.isArray(answer?.[data.rowId])) {
                const multiple = answer?.[data.rowId];
                const idx = multiple.findIndex((i) => i === opt);

                if (idx > -1) {
                  const f = multiple.filter((i) => i !== opt);
                  value = f;
                } else {
                  value = [...multiple, opt];
                }
              } else {
                value = [opt];
              }

              if (value.length === 0) {
                let newAnswer = answer;
                delete newAnswer[data.rowId];
                delete newAnswer[`no-${orderNo}`];
                return handleAnswer({ ...newAnswer });
              }

              sendLogs({
                "quiz_id": quizId,
                "detail_id": data.rowId, 
                "member_id": memberId, 
                "ref_id": refId, 
                "answers": value
              });


              handleAnswer({ ...answer, [data.rowId]: value, [`no-${orderNo}`]: value });
            }}
          >
            {isSingleChoice ? (
              <RadioIcon
                isSelected={opt === answer?.[data.rowId]}
                style={{ flexShrink: 0 }}
              />
            ) : (
              <CheckCircleIcon
                isSelected={
                  Array.isArray(answer?.[data.rowId]) &&
                  answer?.[data.rowId].includes(opt)
                }
                style={{ flexShrink: 0 }}
              />
            )}
            <Text style={[styles.optionTx, { maxWidth: "90%" }]}>{opt}</Text>
          </TouchableOpacity>
        )})
      )}
    </SurveyQuestionCard>
  );
};

const styles = StyleSheet.create({
  option: {
    width: "100%",
    minHeight: 46,
    borderWidth: 1,
    borderRadius: 10,
    padding: 12,
    position: "relative",
    borderColor: "#EAEAEA",
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    gap: 10,
  },
  optionTx: {
    fontFamily: "Archivo-Regular",
    fontStyle: "normal",
    fontSize: 12,
    lineHeight: 14,
    zIndex: 1,
  },
  textInput: {
    height: 100,
    padding: 12,
    borderRadius: 10,
    borderWidth: 1,
    borderColor: "#eaeaea",
    textAlignVertical: "top",
  },
});

export default SurveyDetailCard;
